import { Autocomplete, TextField } from '@mui/material';
import { PartnerPlatform } from '../../interfaces/PartnerPlatform/PartnerPlatform';
import { partnerPlatformNameMap } from '../../constants/PartnerPlatform';

type PartnerPlatformDropdownProps = {
  label?: string;
  disabled?: boolean;
  options?: PartnerPlatform[];
  value?: PartnerPlatform;
  onChange: (newPlatform?: PartnerPlatform) => void;
};

export const PartnerPlatformDropdown = (
  props: PartnerPlatformDropdownProps,
) => {
  const applicablePlatforms =
    props.options ?? (Object.keys(partnerPlatformNameMap) as PartnerPlatform[]);

  return (
    <Autocomplete
      multiple={false}
      size='small'
      disabled={props.disabled}
      fullWidth
      renderInput={(params) => (
        <TextField
          {...params}
          label={props.label}
          variant='outlined'
          fullWidth
        />
      )}
      options={applicablePlatforms}
      getOptionLabel={(option) => partnerPlatformNameMap[option]}
      onChange={(_, selectedPlatform) =>
        props.onChange(selectedPlatform || undefined)
      }
      value={props.value ?? null}
    />
  );
};
